export const randomRange = (min: number, max: number) => Math.random() * (max - min) + min
